



























































































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import moment from "moment";
import Summernote from "@/components/summernote.vue";
import { SupportPopups } from "@/http/api/v2/supporter/popups";
import { SupportPopupDto, SupportPopupSaveDto } from "@/http/dto/supportPopup";

const Modal = namespace("modal");

@Component({ components: { Summernote } })
export default class SupportPopup extends Vue {
  @Modal.Action("showModal") showModal: any;

  status = "all";
  keyword = "";
  current = 1;
  total = 0;
  loading = false;
  errorMessage = "";
  data: SupportPopupDto[] = [];
  summary = { active: 0, scheduled: 0, disabled: 0, ended: 0 };
  modalVisible = false;
  detailLoading = false;
  saving = false;
  deleting = false;
  form: any = this.emptyForm();

  editorConfig: any = {
    height: 360,
    toolbar: [["style", ["style", "fontname", "fontsize", "bold", "italic", "strikethrough", "underline", "color", "clear", "imageUpload", "link", "paragraph", "height", "ul", "ol", "undo", "redo"]]],
  };

  get pagination() {
    return { total: this.total, pageSize: 20, current: this.current, showTotal: (total: number) => `총 ${this.number(total)}개`, showSizeChanger: false };
  }

  get columns() {
    return [
      { title: "순서", dataIndex: "displayOrder", width: 80, fixed: "left", scopedSlots: { customRender: "order" } },
      { title: "팝업", dataIndex: "popup", width: 410, scopedSlots: { customRender: "popup" } },
      { title: "상태", dataIndex: "status", width: 110, scopedSlots: { customRender: "status" } },
      { title: "노출 기간", dataIndex: "period", width: 210, scopedSlots: { customRender: "period" } },
      { title: "최근 수정", dataIndex: "updatedTime", width: 150, scopedSlots: { customRender: "updated" } },
      { title: "관리", dataIndex: "actions", width: 180, fixed: "right", scopedSlots: { customRender: "actions" } },
    ];
  }

  mounted() { this.load(); }
  emptyForm() { return { objectId: "", title: "", htmlContents: "", isEnabled: true, displayOrder: 0, startTime: null, endTime: null }; }
  number(value: number) { return Number(value || 0).toLocaleString("ko-KR"); }
  dateTime(value?: string, empty = "-") { return value ? moment(value).format("YYYY.MM.DD HH:mm") : empty; }
  relativeTime(value: string) { const days = moment().diff(moment(value), "days"); return days < 1 ? "오늘" : days < 30 ? `${days}일 전` : moment(value).format("YYYY.MM.DD"); }
  statusText(value: string) { return ({ active: "노출 중", scheduled: "예약", disabled: "사용 중지", ended: "종료" } as any)[value] || value; }
  statusColor(value: string) { return ({ active: "green", scheduled: "blue", disabled: "default", ended: "orange" } as any)[value] || "default"; }
  errorText(error: any, fallback: string) { return (error && error.response && error.response.data && error.response.data.message) || fallback; }
  changeFilter() { this.current = 1; this.load(); }
  search() { this.current = 1; this.load(); }

  async load(pagination?: any) {
    try {
      this.loading = true;
      this.errorMessage = "";
      const result = await SupportPopups.getPopups({ page: pagination && pagination.current ? pagination.current : this.current, take: 20, status: this.status, keyword: this.keyword || undefined });
      this.current = result.page;
      this.total = result.total;
      this.data = result.items;
      this.summary = { active: result.activeTotal, scheduled: result.scheduledTotal, disabled: result.disabledTotal, ended: result.endedTotal };
    } catch (error) {
      this.errorMessage = "팝업 운영 정보를 불러오지 못했습니다. 잠시 후 다시 시도해주세요.";
    } finally {
      this.loading = false;
    }
  }

  openCreate() { this.form = this.emptyForm(); this.modalVisible = true; }

  async openEdit(objectId: string) {
    this.modalVisible = true;
    this.detailLoading = true;
    try {
      const detail = await SupportPopups.getPopup(objectId);
      this.form = { ...detail, startTime: detail.startTime ? moment(detail.startTime) : null, endTime: detail.endTime ? moment(detail.endTime) : null };
    } catch (error) {
      this.$message.error(this.errorText(error, "팝업 정보를 불러오지 못했습니다."));
      this.modalVisible = false;
    } finally {
      this.detailLoading = false;
    }
  }

  closeModal() { if (this.saving) return; this.modalVisible = false; this.form = this.emptyForm(); }

  validateForm() {
    if (!this.form.title || !this.form.title.trim()) return "팝업 제목을 입력해주세요.";
    if (!this.form.htmlContents || !this.form.htmlContents.trim()) return "팝업 내용을 입력해주세요.";
    if (this.form.startTime && this.form.endTime && !moment(this.form.endTime).isAfter(moment(this.form.startTime))) return "종료 시각은 시작 시각보다 늦어야 합니다.";
    return "";
  }

  saveDto(): SupportPopupSaveDto {
    return {
      title: this.form.title.trim(),
      htmlContents: this.form.htmlContents.trim(),
      isEnabled: this.form.isEnabled,
      displayOrder: Number(this.form.displayOrder || 0),
      startTime: this.form.startTime ? moment(this.form.startTime).toISOString() : undefined,
      endTime: this.form.endTime ? moment(this.form.endTime).toISOString() : undefined,
    };
  }

  async save() {
    const validationMessage = this.validateForm();
    if (validationMessage) { this.$message.warning(validationMessage); return; }
    try {
      this.saving = true;
      if (this.form.objectId) { await SupportPopups.update(this.form.objectId, this.saveDto()); this.$message.success("팝업을 수정했습니다."); }
      else { await SupportPopups.create(this.saveDto()); this.$message.success("팝업을 추가했습니다."); }
      this.modalVisible = false;
      this.form = this.emptyForm();
      await this.load();
    } catch (error) {
      this.$message.error(this.errorText(error, "팝업을 저장하지 못했습니다."));
    } finally {
      this.saving = false;
    }
  }

  async deletePopup() {
    if (!this.form.objectId) return;
    try {
      this.deleting = true;
      await SupportPopups.delete(this.form.objectId);
      this.modalVisible = false;
      this.form = this.emptyForm();
      this.$message.success("팝업을 삭제했습니다.");
      await this.load();
    } catch (error) {
      this.$message.error(this.errorText(error, "팝업을 삭제하지 못했습니다."));
    } finally {
      this.deleting = false;
    }
  }

  previewForm() {
    const validationMessage = this.validateForm();
    if (validationMessage) { this.$message.warning(validationMessage); return; }
    this.showModal({ type: "notice-modal", maskClosable: false, props: { data: [{ title: this.form.title, htmlContents: this.form.htmlContents }] } });
  }

  async previewRow(objectId: string) {
    try {
      const popup = await SupportPopups.getPopup(objectId);
      this.showModal({ type: "notice-modal", maskClosable: false, props: { data: [popup] } });
    } catch (error) {
      this.$message.error(this.errorText(error, "팝업 미리보기를 열지 못했습니다."));
    }
  }
}
